import React from 'react';
import PdfPage from './PdfPage';

// data: { basicRows, buildingRows, detailRows } — 각 배열이 비어있으면 해당 섹션 안 그림

function PdfBuilding({ data, officeName, dateLabel }) {
  const hasBasic = data.basicRows?.length > 0;
  const hasBuilding = data.buildingRows?.length > 0;
  const hasDetail = data.detailRows?.length > 0;

  return (
    <PdfPage officeName={officeName} pageLabel="Property Details" dateLabel={dateLabel} className="p06">
      <div className="p06__chapter">
        <span className="eyebrow">Details</span>
        <h2 className="title">
          {hasDetail ? '세부정보' : '기본정보 · 건물정보'}
        </h2>
      </div>

      <div className="p06__body p07__cols">
        {hasBasic && (
        <section>
          <h3 className="p06__sec-h">기본정보 <span className="en">Basic</span></h3>
          <dl className="p06__profile p07__profile">
            {data.basicRows.map((row, i) => (
              <div className="p06__row" key={i}>
                <dt>{row.label}</dt>
                <dd>{row.value}{row.unit && <span className="unit">{row.unit}</span>}</dd>
              </div>
            ))}
          </dl>
        </section>
        )}
        {hasBuilding && (
        <section>
          <h3 className="p06__sec-h">건물정보 <span className="en">Building</span></h3>
          <dl className="p06__profile p07__profile">
            {data.buildingRows.map((row, i) => (
              <div className="p06__row" key={i}>
                <dt>{row.label}</dt>
                <dd>{row.value}{row.unit && <span className="unit">{row.unit}</span>}</dd>
              </div>
            ))}
          </dl>
        </section>
        )}
        {hasDetail && (
        <section>
          <h3 className="p06__sec-h">세부정보 <span className="en">Details</span></h3>
          <dl className="p06__profile p07__profile">
            {data.detailRows.map((row, i) => (
              <div className="p06__row" key={i}>
                <dt>{row.label}</dt>
                <dd>{row.value}{row.unit && <span className="unit">{row.unit}</span>}</dd>
              </div>
            ))}
          </dl>
        </section>
        )}
      </div>
    </PdfPage>
  );
}

export default PdfBuilding;
